import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Menu, Layout, Tooltip } from 'antd';
import {
  TeamOutlined,
  ToolOutlined,
  AuditOutlined,
  SyncOutlined,
  VideoCameraOutlined,
  PlusSquareOutlined,
  BookOutlined,
  FundOutlined,
  CalculatorOutlined,
} from '@ant-design/icons';
import { withTranslation } from 'react-i18next';
const { Sider } = Layout;

let NAV_ITEMS = [
  // {
  //   title: 'sideBar.roadRepairPlans',
  //   link: '/list',
  //   icon: <BranchesOutlined />,
  // },
  {
    title: 'Госуслуги',
    link: '/gosuslugy',
    icon: <AuditOutlined />,
  },
  // {
  //   title: 'sideBar.intersections',
  //   link: '/crosses',
  //   icon: <DragOutlined />,
  // },
  // {
  //   title: 'sideBar.addRoadRepairPlan',
  //   link: '/list/add',
  //   icon: <PlusOutlined />,
  // },
  {
    title: 'sideBar.configuringUsers',
    link: '/users/list',
    icon: <TeamOutlined />,
  },
  {
    title: 'sideBar.settingUpRoles',
    link: '/roles/list',
    icon: <ToolOutlined />,
  },
  // {
  //   title: 'sideBar.settingUpDirectories',
  //   link: '/catalogs',
  //   icon: <DiffOutlined />,
  // },
  // {
  //   title: 'sideBar.makeSchedule',
  //   link: '/passenger-transport',
  // },
  // {
  // Вернуть после
  //   title: 'sideBar.userActions',
  //   link: '/user-actions',
  //   icon: <HistoryOutlined />,
  // },
  {
    title: 'sideBar.updateData',
    link: '/data-update',
    icon: <SyncOutlined />,
  },
  {
    title: 'sideBar.videoStreams',
    link: '/video-streams',
    icon: <VideoCameraOutlined />,
  },
  {
    title: 'sideBar.healthCare',
    link: '/health-care',
    icon: <PlusSquareOutlined />,
  },
  {
    title: 'sideBar.analytics',
    link: '/analytics',
    icon: <FundOutlined />,
  },
  {
    title: 'sideBar.preschools',
    link: '/preschools',
    icon: <BookOutlined />,
  },
  {
    title: 'sideBar.budget',
    link: '/budget',
    icon: <CalculatorOutlined />,
  },
];

class SidebarComponent extends Component {
  state = {
    collapsed: true,
  };

  render() {
    let { t, collapsed } = this.props;

    const route = this.props.route.pathname;
    NAV_ITEMS.forEach((it) => {
      if (it.link === route) it.active = true;
      else it.active = false;
    });
    return (
      <Sider
        width={200}
        style={{ background: '#fff', display: collapsed ? 'none' : 'block' }}
        collapsible
        collapsed={collapsed}
      >
        <Menu mode="inline" style={{ height: '100%', borderRight: 0 }}>
          {NAV_ITEMS.map((item, index) => (
            <Menu.Item key={index} className={item.active ? 'ant-menu-item-selected' : ''}>
              <Tooltip title={t(item.title)} placement="right">
                <span style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                  <Link
                    to={item.link}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      color: 'initial',
                      width: '100%',
                    }}
                  >
                    {item.icon}
                    {!collapsed && (
                      <span
                        style={{
                          marginLeft: 10,
                          flex: 1,
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {t(item.title)}
                      </span>
                    )}
                  </Link>
                </span>
              </Tooltip>
            </Menu.Item>
          ))}
        </Menu>
      </Sider>
    );
  }
}
export default withTranslation()(SidebarComponent);
